import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Native (Capacitor) can't rely on the httponly cookie, so attach the stored
// session token as a Bearer header. Web is unaffected (no token stored).
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("jeeo_session_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
